import { useEffect, useRef, useState } from "react";
import "../StayUpToDate/StayUpToDateComponents/StayUpToDateComponentsWrapper.css";
import "./LandingComponentsWrapper.css";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { useLocation } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { updateIndexValue } from "../../../Utils/SupabaseServices/StayUpToDateDatabase";
import StayUpToDateSkeleton from "../StayUpToDate/StayUpToDateComponents/StayUpToDateSkeleton";
import CreatorLandingProfile from "../../../components/CreatorProfile/CreatorLandingProfile";
import SubComponentsWrapper from "../LandingPageCarousels/SubComponentsWrapper/SubComponentsWrapper";
import { BsPlusLg } from "react-icons/bs";
import { isMobile } from "react-device-detect";
import ComponentDeleteModal from "../../../components/DeleteModal/ComponentDeleteModal";

const LandingComponentsWrapper = (props: any) => {
  const {
    username,
    user_id,
    StayUpToDateComponents,
    StayUpToDateComponentsLoading,
    refetch,
    brand_color,
    refatchStayUpToDate,
    showModal,
    refetchUser,
    isLoading,
    data,
    refetchUserDetail,
    from = "landing-page",
  } = props;
  const [localData, setLocalData] = useState(StayUpToDateComponents);
  const location = useLocation();
  const [triggered, setTriggered] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    // refetch();
    setLocalData(StayUpToDateComponents);
  }, [StayUpToDateComponents]);
  const [selectedComponent, setSelectedComponent] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [status, setStatus] = useState("");
  const [displayedItems, setDisplayedItems] = useState(5);

  // Simple cleanup function for dragging state
  const cleanupDraggingState = () => {
    const allDraggingElements = document.querySelectorAll(".dragging");
    allDraggingElements.forEach((element) => {
      element.classList.remove("dragging");
    });

    const allRbdDraggingElements = document.querySelectorAll(
      "[data-rbd-dragging='true']"
    );
    allRbdDraggingElements.forEach((element) => {
      element.removeAttribute("data-rbd-dragging");
    });

    document.documentElement.style.scrollBehavior = "";
    document.body.style.scrollBehavior = "";
  };

  // Add a simple click handler to clean up dragging state
  useEffect(() => {
    const handleClick = () => {
      const draggingElements = document.querySelectorAll(".dragging");
      const rbdDraggingElements = document.querySelectorAll(
        "[data-rbd-dragging='true']"
      );
      if (draggingElements.length > 0 || rbdDraggingElements.length > 0) {
        cleanupDraggingState();
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  useEffect(() => {
    refetchUserDetail();
    refetch();
    refetchUser();
  }, [status, StayUpToDateComponents, data?.combinedRes?.userData]);

  // Add additional useEffect to refetch when component mounts or view changes
  useEffect(() => {
    refetchUserDetail();
    refetch();
    refetchUser();

    // Force refetch after a short delay to ensure all data is fresh
    setTimeout(() => {
      refetchUserDetail();
      refetch();
      refetchUser();
    }, 100);
  }, [from]); // Trigger when the 'from' prop changes (e.g., when switching views)

  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }
    // if(result.type === "MAIN"){
    const newData = [...localData];

    const [removed] = newData.splice(result.source.index, 1);

    newData.splice(result.destination.index, 0, removed);
    setLocalData([...newData]);
    updateIndexValue(user_id, newData);
    // }
  };

  async function handleDelete(name: any) {
    setSelectedComponent(name);
    setOpenDeleteModal(true);
  }

  return (
    <div className="stay-up-to-date-wrapper landing-mt-53">
      {isLoading ? (
        <div
          className={
            !(props.isCreator || location.pathname.includes("/preview"))
              ? "skeleton-creator mb-4"
              : "skeleton-creator-page mb-4"
          }
        >
          <Skeleton circle className="creator-img-skeleton hw-100" />
        </div>
      ) : (
        <CreatorLandingProfile
          userDetails={data?.combinedRes?.userData}
          showIcons={data?.combinedRes?.feedControls?.showIcons}
          liveView={location.pathname.includes("/preview") ? false : true}
          username={username}
          showSocialLinks={data?.combinedRes?.feedControls.showSocialLinks}
          socialLinks={data?.combinedRes?.userData}
          description={data?.combinedRes?.description}
          desiredOrder={data?.combinedRes?.userData?.social_links_order?.split(
            ","
          )}
          isUserDashboard={true}
          refetch={refetchUserDetail}
          refetchUser={refetchUser}
          refetchDashboard={refetch}
        />
      )}
      {StayUpToDateComponentsLoading || isLoading ? (
        <div className="loader-container">
          <StayUpToDateSkeleton />
        </div>
      ) : (
        <>
          <div
            id="landing-wrapper"
            className="component-box-outer landing-wrapper"
          >
            <button
              className="primary-add-button"
              onClick={showModal}
              aria-label="Add Page Component"
            >
              <BsPlusLg className="primary-add-icon" />
              <span className="primary-add-text">Add Component</span>
            </button>
            <DragDropContext
              onDragStart={(start) => {
                document.documentElement.style.scrollBehavior = "unset";
                document.body.style.scrollBehavior = "unset";

                // Remove any existing dragging classes first
                const existingDraggingElements =
                  document.querySelectorAll(".dragging");
                existingDraggingElements.forEach((element) => {
                  element.classList.remove("dragging");
                });

                const draggedElement = document.querySelector(
                  `[data-rbd-draggable-id="${start.draggableId}"]`
                );
                draggedElement?.classList.add("dragging");
              }}
              onDragEnd={(result) => {
                // Restore scroll behavior
                document.documentElement.style.scrollBehavior = "";
                document.body.style.scrollBehavior = "";

                // Remove dragging class from all elements
                const allDraggingElements =
                  document.querySelectorAll(".dragging");
                allDraggingElements.forEach((element) => {
                  element.classList.remove("dragging");
                });

                // Also remove react-beautiful-dnd's data-rbd-dragging attribute
                const allRbdDraggingElements = document.querySelectorAll(
                  "[data-rbd-dragging='true']"
                );
                allRbdDraggingElements.forEach((element) => {
                  element.removeAttribute("data-rbd-dragging");
                });

                // Reset any inline styles that react-beautiful-dnd might have added
                const allDraggableElements = document.querySelectorAll(
                  "[data-rbd-draggable-id]"
                );
                allDraggableElements.forEach((element) => {
                  const el = element as HTMLElement;
                  // Reset transform, transition, and z-index
                  el.style.transform = "";
                  el.style.transition = "";
                  el.style.zIndex = "";
                  el.style.position = "";
                  el.style.top = "";
                  el.style.left = "";
                  el.style.width = "";
                  el.style.height = "";

                  // Add reset class to force visual reset
                  el.classList.add("drag-reset");
                  // Remove reset class after a short delay
                  setTimeout(() => {
                    el.classList.remove("drag-reset");
                  }, 50);
                });

                // Force a reflow
                void document.body.offsetHeight;

                onDragEnd(result);
              }}
            >
              <Droppable
                droppableId="droppable"
                direction="vertical"
                type="column"
              >
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="droppable-container"
                    style={{
                      touchAction: "pan-y",
                      height: "100%",
                    }}
                  >
                    {localData &&
                      localData.map((component: any, index: number) => (
                        <SubComponentsWrapper
                          key={component.id}
                          component={component}
                          index={index}
                          user_id={user_id}
                          username={username}
                          refetch={refetch}
                          brand_color={brand_color}
                          handleDelete={handleDelete}
                          refatchStayUpToDate={refatchStayUpToDate}
                          setStatus={setStatus}
                          selectedComponent={selectedComponent}
                          setSelectedComponent={setSelectedComponent}
                          isEdit={isEdit}
                          setIsEdit={setIsEdit}
                          isEditModalOpen={isEditModalOpen}
                          setIsEditModalOpen={setIsEditModalOpen}
                          from={from}
                        />
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          <ComponentDeleteModal
            openDeleteModal={openDeleteModal}
            selectedComponent={selectedComponent}
            user_id={user_id}
            refetch={refetch}
            username={username}
            localData={localData}
            setLocalData={setLocalData}
            setOpenDeleteModal={setOpenDeleteModal}
            displayedItems={displayedItems}
            setDisplayedItems={setDisplayedItems}
          />
        </>
      )}
    </div>
  );
};

export default LandingComponentsWrapper;
